import {
    ActionPointInfo,
    Controller,
    IActionPointInfo,
    Menu,
    Toolbar,
} from '@tencent/workbench';
import { InsertTableFeature } from '@framework/workbench/ui/insert/insert-table/insert-table-feature';
import { INSERT_CONFIGS, config, TOOLBAR_ITEMS } from './config';

@Controller({
    menuItems: INSERT_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class InsertTableController {
    constructor(private readonly feature: InsertTableFeature) {
    }

    @Menu(`${config.id}-custom`, 'content')
    public getPcBtnDropdownContent(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getContent(info);
    }

    @Toolbar(`${config.id}-custom`, 'dropdownContent')
    public getInsertTableDropdownContent(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getContent(info);
    }

    @Toolbar(`${config.id}-custom`, 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }

    @Menu(config.id, 'shouldDisabled')
    @Toolbar(`${config.id}-custom`, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }
}
